/*!
 * RequireJS plugin for async dependency load like JSONP and Google Maps
 * @author Miller Medeiros
 * @version 0.0.1 (2011/03/23)
 * Released under the MIT License <http://www.opensource.org/licenses/mit-license.php>
 */
mmf_modules.define('require_async',[],function(){

    function injectScript(src){
        var s, t;
        s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = src;
        t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s,t);
    }

    function formatUrl(name, id){
        var paramRegex = /!(.+)/,
            url = name.replace(paramRegex, ''),
            param = (paramRegex.test(name))? name.replace(/.+!/, '') : 'callback'; //default param name is 'callback'
        url += (url.indexOf('?') < 0)? '?' : '&';
        return url + param +'='+ id;
    }

    return{
        load : function(name, req, onLoad, config){
            if(config.isBuild){
                onLoad(null); //avoid errors on the optimizer
            }else{
                var id = '__mm_asynch_req__'+ (+new Date());
                window[id] = onLoad; //create a global variable that stores onLoad so callback function can define new module after async load
                injectScript(formatUrl(name, id));
            }
        }
    };
});
